var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 25,
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 25",
    stroke: "#707d9d",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square",
    strokeWidth: 2,
    transform: "translate(1 1.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 10.97a1.997 1.997 0 00-2-1.995h-1.262a7.933 7.933 0 00-.852-2.052l.892-.89a1.99 1.99 0 000-2.82 2.004 2.004 0 00-2.828 0l-.892.89A7.98 7.98 0 0013 3.253V1.994C13 .894 12.105 0 11 0S9 .893 9 1.994v1.259a7.98 7.98 0 00-2.058.85l-.892-.89a2.004 2.004 0 00-2.828 0 1.99 1.99 0 000 2.82l.892.89a7.933 7.933 0 00-.852 2.052H2c-1.104 0-2 .893-2 1.995 0 1.101.895 1.994 2 1.994h1.262c.189.73.477 1.418.852 2.052l-.892.89a1.99 1.99 0 000 2.82 2.004 2.004 0 002.828 0l.892-.89a7.965 7.965 0 002.058.85v1.259c0 1.1.895 1.994 2 1.994s2-.892 2-1.994v-1.259a7.98 7.98 0 002.058-.85l.892.89a2.004 2.004 0 002.828 0 1.99 1.99 0 000-2.82l-.892-.89a7.919 7.919 0 00.852-2.052H20c1.104 0 2-.893 2-1.994z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11,
    cy: 10.97,
    rx: 3,
    ry: 2.992
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.dc413b16.svg";
export { ForwardRef as ReactComponent };